import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InfoRow from "../common/InfoRow";
import PercentageIcon from "@mui/icons-material/Percent";

const TaxCodeCard = ({ taxCode, onEdit, onDelete }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={1}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h6" fontWeight="bold" noWrap>
                {taxCode.name}
              </Typography>
              <Chip
                label={taxCode.code}
                size="small"
                variant="outlined"
                sx={{ fontWeight: "bold", height: 20, fontSize: "0.65rem" }}
              />
            </Stack>
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        {/* Details Body */}
        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={<PercentageIcon fontSize="small" />}
            label="Applied Rate"
            value={`${parseFloat(taxCode.taxRate).toFixed(2)}%`}
          />
          <InfoRow
            icon={<ReceiptLongIcon fontSize="small" color="action" />}
            label="Internal Code"
            value={taxCode.code}
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default TaxCodeCard;
